import React, { useState, useEffect, useRef, useCallback } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions, 
  Button, Box, Typography, Alert, CircularProgress 
} from '@mui/material';
import { Html5Qrcode } from 'html5-qrcode';

const SCANNER_ID = 'qr-modal-recepcion-container';

const ModalEscaneoRecepcion = ({ open, onClose, onResult }) => {
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const scannerRef = useRef(null);
  const isProcessingRef = useRef(false);

  const stopScanner = useCallback(async () => {
    if (scannerRef.current) {
      try {
        const state = scannerRef.current.getState();
        if (state >= 2) await scannerRef.current.stop();
      } catch (e) { console.warn(e); }
      scannerRef.current = null;
    }
  }, []);

  const startScanner = useCallback(async () => {
    setError('');
    setLoading(false);
    isProcessingRef.current = false;
    await stopScanner();
    await new Promise(r => setTimeout(r, 450)); // Delay para que el DOM del Modal esté listo

    try {
      const scanner = new Html5Qrcode(SCANNER_ID);
      scannerRef.current = scanner;
      await scanner.start(
        { facingMode: 'environment' },
        { 
          fps: 10, 
          qrbox: { width: 250, height: 250 },
          // ELIMINAMOS aspectRatio: 1.0 para evitar las 3 imágenes
        },
        (text) => {
          if (isProcessingRef.current) return;
          isProcessingRef.current = true;
          setLoading(true);
          onResult(text); // Enviamos el texto al padre
        },
        () => {}
      );
    } catch (err) {
      setError('No se pudo acceder a la cámara.');
    }
  }, [stopScanner, onResult]);

  useEffect(() => {
    if (open) startScanner();
    else stopScanner();
    return () => stopScanner();
  }, [open, startScanner, stopScanner]);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Escaneando Código QR</DialogTitle>
      <DialogContent>
        {error && <Alert severity="error">{error}</Alert>}
        <Box sx={{ position: 'relative', bgcolor: '#000', borderRadius: 2, overflow: 'hidden', minHeight: '300px' }}>
          <div id={SCANNER_ID} style={{ width: '100%' }} />
          {loading && (
            <Box sx={{ position: 'absolute', inset: 0, bgcolor: 'rgba(0,0,0,0.7)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white', zIndex: 10 }}>
              <CircularProgress color="inherit" />
            </Box>
          )}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="inherit">Cancelar</Button>
      </DialogActions>
    </Dialog>
  );
};

export default ModalEscaneoRecepcion;